import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Typography,
  Flex,
  Grid,
  DatePicker,
  message,
} from "antd";
import { App, Select } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateContra, fetchContraList } from "../contraThunks";
import { setSelectedContra, setIsEditContra } from "../contraSlice";
import dayjs from "dayjs";
import { fetchAccountsForContra, fetchContraCode } from "../contraThunks";
import { selectContraAccounts, selectContraCode } from "../contraSelectors";
import {
  fetchTagGroups,
  fetchTagGroupFields,
} from "../../../store/commonThunks/lookups";
import InputNumberField from "../../../components/Input/InputNumber";
import { getAccessType } from "../../../lib/functions";
import AddNewModal from "../../../components/DropDown/AddNewModal";
import TagCreateForm from "../../Settings/Tags/components/TagCreateForm";
import { selectAuthInfo } from "../../Auth/authSelectors";
import useMigrationDate from "../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateContraForm = () => {
  const authInfo = useSelector(selectAuthInfo);
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();

  const { isEditContra, selectedContra } = useSelector((state) => state.contra);

  const accounts = useSelector(selectContraAccounts);
  const contraCode = useSelector(selectContraCode);
  const lookups = useSelector((s) => s.lookups);
  const [tagModal, setTagModal] = useState(false);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("contra_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchAccountsForContra()); // load accounts for dropdown
    dispatch(fetchContraCode());
    dispatch(fetchTagGroups());
    dispatch(fetchTagGroupFields());
  }, [dispatch]);
const {disabledDate}= useMigrationDate();
  useEffect(() => {
    if (contraCode) {
      form.setFieldsValue({ contra_code: contraCode });
    }
  }, [contraCode, form]);

  useEffect(() => {
    if (isEditContra && selectedContra) {
      form.setFieldsValue({
        contra_id: selectedContra.contra_id,
        created_date: dayjs(selectedContra.created_date),
        from_acc_id: selectedContra.from_acc_id,
        to_acc_id: selectedContra.to_acc_id,
        tran_amount: Number(selectedContra.tran_amount),
        narration: selectedContra.narration,
        contra_code: selectedContra.contra_code,
      });

      if (selectedContra.tag_field_id && selectedContra.tag_field_id !== 0) {
        form.setFieldsValue({ tag_field_id: selectedContra.tag_field_id });
      }

    } else {
      form.resetFields();
      form.setFieldsValue({
        created_date: dayjs(),
      });
    }
  }, [isEditContra, selectedContra]);

  const handleCancel = () => {
    dispatch(setSelectedContra(null));
    dispatch(setIsEditContra(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      if (values.from_acc_id === values.to_acc_id) {
        modal.warning({
          title: "From Account and To Account cannot be the same",
        });
        return;
      }
      const payLoad = {
        contra_code: values.contra_code?.trim(),
        created_date: values.created_date.format("YYYY-MM-DD"), // or use formatToUtc if you had a util
        from_acc_id: values.from_acc_id,
        to_acc_id: values.to_acc_id,
        tran_amount: values.tran_amount === "" ? 0 : values.tran_amount,
        narration: values.narration || "",
        contra_id: selectedContra?.contra_id || 0,
        action: isEditContra ? "update" : "create",
      };


      // optional tag field
      if (values.tag_field_id && values.tag_field_id !== 0) {
        payLoad.tag_field_id = values.tag_field_id;
      }
      await dispatch(createOrUpdateContra(payLoad)).unwrap();

      modal.success({
        title: isEditContra
          ? "Contra updated successfully"
          : "Contra created successfully",
      });

      dispatch(setSelectedContra(null));
      dispatch(setIsEditContra(false));
      navigate("/accounts/contra-entry");
      dispatch(fetchContraList());
      dispatch(fetchContraCode());
    } catch (error) {
      modal.warning({
        title: error?.msg || error?.message || "Save failed",
      });
    }
  };

  return (
    <div className="contra-form">
      <Title
        level={2}
        style={{
          marginBottom: "32px",
          wordBreak: "break-word",
          fontSize: screens.md ? undefined : "28px",
        }}
      >
        {isEditContra ? "Update Contra Entry" : "Create New Contra Entry"}
      </Title>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        className="responsive-form"
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
        initialValues={{
          contra_code: contraCode,
        }}
        requiredMark={(label, { required }) =>
          required ? (
            <>
              {label} <span style={{ color: "#ff4d4f" }}>*</span>
            </>
          ) : (
            label
          )
        }
      >
        <Form.Item
          style={{
            marginTop: "24px",
          }}
        >
          
        </Form.Item>

        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="From Account"
              name="from_acc_id"
              rules={[{ required: true, message: "From Account is required" }]}
            >
              <Select
                placeholder="Select From Account"
                data-testid="select-from-account"
                options={accounts.map((acc) => ({
                  label: acc.acc_name,
                  value: acc.acc_id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Amount"
              name="tran_amount"
              rules={[
                { required: true, message: "Amount is required" },
                {
                  type: "number",
                  min: 1,
                  message: "Amount must be greater than 0",
                },
              ]}
            >
              <InputNumberField
                min={0}
                step={1} // allow decimal steps
                precision={2}
                style={{ width: "100%" }}
                data-testid="input-tran-amount"
              />
            </Form.Item>

            <Form.Item label="Tag" name="tag_field_id">
              <Select
                mode="multiple"
                maxTagCount="responsive"
                className="tag-multiselect"
                placeholder="Select Tag(s)"
                options={lookups.tagFields.map((tag) => ({
                  label: tag.display_text,
                  value: tag.id,
                }))}
                popupRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 8,
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <Button type="link" onClick={() => setTagModal(true)}>
                        + Add New Tag
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>

            <Form.Item label="Narration" name="narration">
              <InputField
                placeholder="Enter Narration"
                data-testid="input-narration"
              />
            </Form.Item>
          </Flex>

          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "45%" }}
          >
            <Form.Item
              label="To Account"
              name="to_acc_id"
              rules={[{ required: true, message: "To Account is required" }]}
            >
              <Select
                data-testid="select-to-account"
                placeholder="Select To Account"
                options={accounts.map((acc) => ({
                  label: acc.acc_name,
                  value: acc.acc_id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Voucher Date"
              name="created_date"
              rules={[{ required: true, message: "Voucher Date is required" }]}
            >
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY"   disabledDate={disabledDate} />
            </Form.Item>

            <Form.Item label="Contra Code" name="contra_code">
              <InputField disabled />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && (
            <>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="traic-button"
                data-testid="save-contra-btn"
              >
                {isEditContra ? "Update" : "Save"}
              </Button>
            </>
          )}
        </Flex>
      </Form>
      <AddNewModal
        open={tagModal}
        title="Add Tag"
        onClose={() => setTagModal(false)}
      >
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();

            const match = res.find(
              (t) =>
                t?.raw?.field_name?.toLowerCase() === createdName.toLowerCase()
            );

            if (!match) {
              message.warning("Tag creation failed or tag not found");
              setTagModal(false);
              return;
            }

            const current = form.getFieldValue("tag_field_id") || [];

            if (current.includes(match.id)) {
              message.info("Tag already exists and is already selected");
              setTagModal(false);
              return;
            }

            // ✅ AUTO SELECT (Form-based)
            form.setFieldsValue({
              tag_field_id: [...current, match.id],
            });

            message.success("Tag added");
            setTagModal(false);
          }}
        />
      </AddNewModal>
    </div>
  );
};

export default CreateContraForm;
